import { makeStyles, withStyles } from "@material-ui/core";
import { Grid, Button, Typography, Card, CardContent, Divider, TextField, Hidden, Link, IconButton } from "@material-ui/core";
import { history } from "../../../../helpers/history";
import { routePaths } from "../../../config/route-paths";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Skeleton } from "@material-ui/lab";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import { commonService } from "../../../../services/common.service";
import { useMediaQuery } from "react-responsive";
import { adminService } from "../../../../services";
import { config } from "../../../../enviroment";
import EFooter from "../../../e_home-page/e_footer-section/view/_footer";
import Close from "@material-ui/icons/Close";
import { Dialog, DialogContent, DialogActions, DialogTitle } from "@material-ui/core";
import WarningRoundedIcon from '@material-ui/icons/WarningRounded';
import { useTranslation } from "react-i18next";

export const OutlinedTextFiled = withStyles((theme) => ({
    root: {
        "& .MuiOutlinedInput-input": {
            padding: "0.5rem !important",
            fontSize: "0.8rem",
            backgroundColor: theme?.palette?.eWhite?.base,
        },
        "& .MuiFormHelperText-root.Mui-error": {
            margin: "0 !important",
        },
    },
}))(TextField);

const useStyles = makeStyles((theme) => ({
    root: {
        minHeight: "90vh",
        overflow: "auto"
    },
    contentBg: {
        background: theme?.palette?.eLight?.base + " !important",
        padding: "1.5rem 1.5rem 0rem !important",
        paddingBottom: 0,
        [theme.breakpoints.down("xs")]: {
            padding: "0px !important",
            paddingBottom: "8%"
        },
    },
    heading: {
        fontWeight: "bold",
        marginTop: "4%",
        color: theme?.palette?.ePrimary?.base + "!important",
    },
    heading2: {
        color: theme?.palette?.ePrimary?.base,
        fontWeight: "bold",
    },
    skeleton: {
        background: theme?.palette?.eDark?.base
    },
    disabledSubmitButton: {
        background: theme?.palette?.eLight?.base + "!important",
        borderRadius: 29,
        [theme.breakpoints.down("sm")]: {
            width: "38vw",
            align: "center"
        },
        [theme.breakpoints.up("md")]: {
            width: "8vw",
        },
        marginTop: "2%"
    },  buttonsDiv:{
        display:"flex",
        justifyContent:"flex-end",
      },
    trackbutton: {
        [theme.breakpoints.down("sm")]: {
            width: "38vw",
            align: "center"
        },
        [theme.breakpoints.up("md")]: {
            width: "8vw",
        },
        "&:hover": {
            backgroundColor: theme?.palette?.ePrimary?.hover,
        },
        borderRadius: 29,
        backgroundColor: theme?.palette?.ePrimary?.base,
        color: theme?.palette?.eWhite?.base,
        marginTop: "2%"
    },
    font: {
        [theme.breakpoints.down("sm")]: {
            marginTop: "3% !important"
        },
        marginTop: "6%",
        color: theme?.palette?.ePrimary?.base + "!important",
    },
    font2: {
        color: theme?.palette?.eDark?.base + "!important",
    },
    textfield: {
        [theme.breakpoints.down("sm")]: {
            marginTop: "4% !important"
        },
        marginTop: "9%"
    },
    img: {
        [theme.breakpoints.down("sm")]: {
            height: "50vh !important"
        },
        height: "80vh",
        backgroundSize: "cover",
        width: "auto",
        marginTop: "2%"
    },
    backButton: {
        [theme.breakpoints.up("md")]: {
            paddingTop: "6% !important",
            paddingLeft:"0% !important"
        },
        color: theme?.palette?.ePrimary?.base,
    },
    dividerColor: {
        backgroundColor: theme?.palette?.eLight?.base,
        marginTop: "1%"
    },
    padding: {
        paddingLeft: "3% !important"
    },
    cardCont: {
        minHeight: "inherit"
    },
    asterisk: {
        color: theme.palette.eDanger?.dark
    },
    skeleton: {
        background: theme?.palette?.eLight?.base,
        color: theme?.palette?.eDark?.base
    }, dialogContainerStyling: {
        "& .MuiDialog-paperWidthSm": {
            [theme.breakpoints.up("sm")]: {
                minWidth: "25rem !important"
            },
            [theme.breakpoints.down("sm")]: {
                minWidth: "20rem !important"
            },
        }
    },
    contentColor: {
        background: theme.palette.ePrimary.base,
        color: theme.palette.eWhite.base,
        paddingLeft: "5%",
    },
    rightIcon: {
        textAlign: "-webkit-right",
    }, closeIcon: {
        color: theme.palette.eWhite.base,
    },
    alertIcon: {
        color: theme?.palette?.eTertiary?.base,
        width: "4rem",
        height: "auto",
        display: "block",
        margin: "1rem auto",
    },
    dialogTextPadding: {
        padding: "0rem 1.875rem 1.875rem",
        textAlign: "center"
    },
    no: {
        color: theme.palette.ePrimary.base,
    },
    yes: {
        backgroundColor: theme.palette.ePrimary.base,
        color: theme.palette.eWhite.base,
        borderRadius: 30,
        "&:hover": {
            backgroundColor: theme.palette.ePrimary.hover,
        },
        padding: "3% 35%",
    },
    backStyle: {
        [theme.breakpoints.down("md")]: {
            "& .MuiButton-root": {
                padding: "0px !important"
            }
        },
    }
}));
export default function TrackingLandingPage() {
    const isSmall = useMediaQuery({ query: "(max-width: 768px)" });
    let [trakerImg, setTrakerImg] = useState();
    const classes = useStyles();
    const [disable, setDisable] = useState(true);
    const [value, setValue] = useState("");
    const { t: labels, ready: labelReady } = useTranslation("label-E_TRACKING_NEW_CONNECTION");
    const { t: contentdata, ready: contentdataReady } = useTranslation("content-E_TRACKING_NEW_CONNECTION")
    const { t: contentsum, ready: contentsumReady } = useTranslation("content-E_SUMMARY_REVIEW")
    const trackLength = useSelector((state) => state?.parametersWidgets?.ParameterLookup?.E_TRACKREQUEST_LIMIT);
    const digitsRegex = useSelector((state) => state?.parametersWidgets?.ParameterLookup?.E_DIGITS_REGEX);
    let trakingImg = useSelector(
        (store) =>
            store?.parametersWidgets?.ParameterLookup?.E_TRACKING_IMG
    );
    const [content, setContent] = useState();
    const [open, setOpen] = useState(false);
    const { t: backlabels, ready: backlabelsReady } = useTranslation("label-E_SUMMARY_REVIEW");
    const handleClickOpen = () => {
        if (value===""){
            setOpen(false);
            history.push(routePaths?.LOGIN);
        }else{
            setOpen(true);
        }
        
    };
    const handleClose = () => {
        setOpen(false);
    };
    useEffect(() => {
        (async () => {
            if (trakingImg) {
                await commonService.getAssestUrl(trakingImg).then((res) => {
                    setTrakerImg(res);
                });
            }
        })();
    }, [trakingImg]);
    let backClick = (e) => {
        history.push(routePaths?.LOGIN);
    }
    const handlerchange = (event) => {
        if (event.target.value.trim() == "") {
            setDisable(true)
            setValue("")
        } else {
            var digitsRegexS = new RegExp(digitsRegex);
            if(digitsRegexS.test(event.target.value)) {
                setValue(event.target.value)
                if(event.target.value.length == trackLength) {
                    setDisable(false)
                } else {
                    setDisable(true)
                }
            }
        }
    }
    const languageCode = useSelector(
        (state) =>
            state?.parametersWidgets?.ParameterLookup?.TENANT_PRIMARY_LANGUAGE
    );

    const tenantCode = config.parameters.TENANT_CODE;
    const buttonhandler = () => {
        history.push(
            `${routePaths.TRACK_REQUEST_STEPS}/${value}`
        )
    }
    return (
        <>
            <Grid className={classes.contentBg}>
                <Card className={classes.root}>
                    <CardContent className={classes.cardCont}>
                        <Grid container spacing={2} direction="column">
                            <Grid item align="left" className={classes.backStyle} xs={12} md={3}>
                                <Button
                                    size="small"
                                    startIcon={<ArrowBackIosIcon fontSize="small" />}
                                    onClick={() => handleClickOpen()}
                                    className={classes.backButton}
                                    variant="caption"
                                >
                                    <b>{labelReady ? labels("E_TRACKING_BACK") : <Skeleton />}</b>
                                </Button>
                            </Grid>
                            <Grid item xs={12} md={6}>
                                {labelReady ? <Typography variant="h5" className={classes.heading2}>{labels("E_TRACKING_TITLE")}</Typography> : <Skeleton />}
                            </Grid>
                        </Grid>
                        <Divider className={classes.dividerColor} />
                         <Grid>
                            <Grid container spacing={1}>
                                <Grid item xs={12} md={5} className={isSmall ? null : classes.padding}>
                                    <Grid container spacing={2}>
                                        <Grid item xs={12}>
                                            {labelReady ?
                                                <Typography variant={isSmall ? "body2" : "h5"} className={classes.font}>{labels("E_TRACKING_HEADING")}</Typography>
                                                : <Skeleton />}
                                        </Grid>
                                        <Grid item xs={12}>
                                        {contentdataReady ?
                                                <Typography variant={isSmall ? "caption" : "body2"} className={classes.font2}> {contentdata("E_TRACKING_TITLE_1").answer}</Typography>
                                                : <Skeleton />}
                                        </Grid>
                                    </Grid>
                                    <Grid container className={classes.textfield}>
                                        <Grid item xs={12}>
                                            {labelReady ?
                                                <Typography variant="caption" className={classes.font2}>
                                                    {labels("E_TRACKING_ENTER_REFERENCE_NUMBER")}<span className={classes.asterisk}>*</span>
                                                </Typography>
                                                : <Skeleton />}
                                        </Grid>
                                        <Grid item xs={12}>
                                            <OutlinedTextFiled
                                                fullWidth
                                                name="emailId"
                                                size="small"
                                                variant="outlined"
                                                inputProps={{
                                                    maxLength: Number(trackLength),
                                                }}
                                                placeholder={labelReady ? labels("E_TRACKING_PLACEHOLDER") : ""}
                                                onChange={handlerchange}
                                                value={value}
                                            />
                                        </Grid>
                                    </Grid>
                                    <Hidden smDown>
                                        <Grid item xs={12} md={12} className={classes.buttonsDiv}>
                                            <Button variant="body1" disabled={disable}
                                                className={disable ? classes.disabledSubmitButton : classes.trackbutton}
                                                onClick={buttonhandler}>{labelReady ? labels("E_TRACKING_TRACK") : ""}</Button>
                                        </Grid>
                                    </Hidden>
                                </Grid>
                                <Grid item xs={12} md={7} align="center" >
                                    <img className={classes.img} src={trakerImg?.assetPath} alt={labelReady ? labels("E_TRACKING_FALLBACK_TEXT") : ""} />
                                </Grid>
                                <Hidden mdUp>
                                    <Grid item xs={12} md={6} align="center">
                                        <Button variant="body1" disabled={disable}
                                            className={disable ? classes.disabledSubmitButton : classes.trackbutton}
                                            onClick={buttonhandler}>{labelReady ? labels("E_TRACKING_TRACK") : ""}</Button>
                                    </Grid>
                                </Hidden>
                            </Grid>
                        </Grid> 
                    </CardContent>
                </Card>
                <Grid align="center"><EFooter /></Grid>
                <Dialog onClose={handleClose} open={open} className={classes.dialogContainerStyling}>
                    <Grid
                        container
                        alignItems="center"
                        className={classes.contentColor}
                        justify="space-between"
                    >
                        <Grid item xs={10}>
                            {backlabelsReady ?
                                <Typography variant="subtitle2">{backlabels("E_CONFIRMATION_LABEL")}</Typography>
                                : <Skeleton />}
                        </Grid>
                        <Grid item xs={2} className={classes.rightIcon}>
                            <IconButton aria-label="close" onClick={handleClose}>
                                <Close className={classes.closeIcon} />
                            </IconButton>
                        </Grid>
                    </Grid>
                    <DialogContent dividers>
                        <WarningRoundedIcon className={classes.alertIcon} />
                        {
                            contentsumReady ? <Typography className={[classes.detailsSubLine, classes.dialogTextPadding]}
                                dangerouslySetInnerHTML={{
                                    __html:  contentsum("E_SUMMARY_REVIEW_CONFIRMATION").answer ,
                                }}
                            >
                            </Typography> : <Skeleton variant="text"></Skeleton>
                        }

                    </DialogContent>
                    <DialogActions className={classes.dialoagActionPadding}>
                        <Grid item xs={1} sm={1}>
                            <Link component="button" onClick={() => { handleClose() }} underline="hover" className={classes.no}>
                                {backlabelsReady ?
                                    <Typography variant="button" >{backlabels("E_NO_LABEL")}</Typography>
                                    : <Skeleton />}
                            </Link>
                        </Grid>
                        <Grid item xs={3}>
                            <Button
                                className={classes.yes}
                                size="small"
                                align="right"
                                onClick={backClick}
                            >
                                {backlabelsReady ?
                                    <Typography variant="button">{backlabels("E_YES_LABEL")}</Typography>
                                    : <Skeleton />}
                            </Button>
                        </Grid>
                    </DialogActions>
                </Dialog>
            </Grid>
        </>
    );
}